import { groupBy, toArray } from "lodash-es";
import ObjectCopyService from "external-services/object-copy-service/index";
import BookingsAffectedService from "app/services/bookingsAffected/bookingsAffected.service";
import BookingUpdateService from "external-services/booking-update-service/index";

/**
 * Note: this controller gets called from a modal dialog, which is where the html template is defined.
 * Because of this hot reloading will not work.
 */

const NS = 'AffectedBookingsConfirmCtrl'; // jshint ignore:line

export default function AffectedBookingsConfirmCtrl(
  $scope, $mdDialog, bookingConflicts
) {
  "ngInject";

  const vm = this;
  vm.showUpdateError = false;

  /**
   * groups bookings by id and then filters out any duplicates
   */
  const groupedIds = groupBy(bookingConflicts, ({_id}) => _id);
  const uniqueList = toArray(groupedIds).map(grouped => grouped[0]);

  $scope.bookingConflicts = uniqueList;

  $scope.cancel = function () {
    $mdDialog.cancel();
  };

  $scope.confirm = function () {
    $mdDialog.hide();
  };

  // Comment out due to issue NBI-5203
  // will uncomment when there is a new requirement regarding invalid booking
  // $scope.cancel = function () {
  //   $mdDialog.cancel();
  // };
  // $scope.confirm = function () {
  //   let counter = 0;
  //   uniqueList.forEach(booking => {
  //     const orgBooking = ObjectCopyService.angularSafeCopy(booking);

  //     BookingsAffectedService.assignServiceForInvalidBooking(booking)
  //       .then(() => BookingUpdateService.updateFromAnywhere(booking, orgBooking))
  //       .then(() => counter++)
  //       .then(() => {
  //         // only want to close the dialog once, so waits for last item in list
  //         if (counter === uniqueList.length) {
  //           $mdDialog.hide();
  //         }
  //       })
  //       .catch(err => {
  //         vm.showUpdateError = true;
  //         console.warn(NS, 'error', err);
  //       });
  //   });
  // };
}
